import React from "react";
import SettingsLayout from "layouts/settings";

const GlobalSettings: React.FC = () => {
  return <SettingsLayout settingsType="global" basePath="/dashboard/global-settings" />;
};

export default GlobalSettings;